import api from "../../components/api"
import { CustomerEmail } from "./customer"

export const getCustomerEmails = async (customerId: number): Promise<CustomerEmail[]> => {
  return (await api.get(`/web/customers/${customerId}/emails`)).data
}
